import "./ProductHeader.scss";

const ProductsHeader = ({ category }) => {
  // convert copy to json and make this dynamic
  return (
    <div className="section container">
      {category === "chairs" ? (
        <section>
          <div>
            <h1>Chairs</h1>
            <p>Seating for sale</p>
            <p>
              Please keep in mind that these items may be sold at any time. Give
              us a call to verify availability. All items are sold as-is. Items
              are sold on a first-come, first-served basis. No item is sold
              until full payment is received. We prefer that you inspect the
              furniture prior to purchase.
            </p>
          </div>
          <div>
            <div>
              <div>
                <p className="highlight inline-block bold">
                  ITEM MARKED AS NEW OR SPECIAL ORDER WILL BE SUBJECTED TO PRICE
                  INCREASE AS WHOLE SELLER MAY INCREASE THEIR PRICING. PLEASE
                  CALL FOR THE MOST UP TO DATE PRICING!
                  {/* SOME ITEMS MARKED AS *NEW* MAY BE SUBJECT TO TARIFF INCREASES. PLEASE CALL FOR MOST UP
    TO DATE PRICING FOR ITEMS MARKED AS NEW. */}
                </p>
              </div>
            </div>
          </div>
        </section>
      ) : null}
      {/* cubicles */}
      {category === "cubicles" ? (
        <section>
          <div>
            <h1>Cubicles</h1>
            <p>Cubicles for sale</p>
            <p>
              Please keep in mind that these items may be sold at any time. Give
              us a call to verify availability. All items are sold as-is. Items
              are sold on a first-come, first-served basis. No item is sold
              until full payment is received. We prefer that you inspect the
              furniture prior to purchase.
            </p>
          </div>
          <div>
            <div>
              <div>
                <p className="highlight inline-block bold">
                  ITEM MARKED AS NEW OR SPECIAL ORDER WILL BE SUBJECTED TO PRICE
                  INCREASE AS WHOLE SELLER MAY INCREASE THEIR PRICING. PLEASE
                  CALL FOR THE MOST UP TO DATE PRICING!
                  {/* SOME ITEMS MARKED AS *NEW* MAY BE SUBJECT TO TARIFF INCREASES. PLEASE CALL FOR MOST UP
    TO DATE PRICING FOR ITEMS MARKED AS NEW. */}
                </p>
              </div>
            </div>
          </div>
        </section>
      ) : null}
    </div>
  );
};

export default ProductsHeader;
